import Request from "@services/request";
import { IGetAllFormData, IGetSingleFormData } from "./types";

const GetAllWithoutFilter = async () =>
    await new Request().get<IReturnValue<Array<IPlatforms["get"]>>>(
        "PLATFORMS_ALL",
    );

const GetAll = async ({ query, page }: IGetAllFormData) =>
    await new Request().get<IReturnValue<Array<IPlatforms["get"]>>>(
        "PLATFORMS",
        {
            params: {
                query,
                page,
            },
        },
    );

const GetSingle = async ({ id }: IGetSingleFormData) =>
    await new Request().get<IReturnValue<IPlatform["get"]>>({
        base: "PLATFORM",
        params: {
            id,
        },
    });

const Create = async ({
    faName,
    enName,
    url,
    description,
    seoDescription,
    seoKeywords,
}: IPlatforms["post"]) =>
    await new Request().post<IPlatforms["post"], IReturnValue<any>>(
        "PLATFORMS",
        {
            faName,
            enName,
            url,
            description,
            seoDescription,
            seoKeywords,
        },
    );

const Edit = async ({
    id,
    faName,
    enName,
    url,
    description,
    seoDescription,
    seoKeywords,
}: IPlatform["put"]) =>
    await new Request().put<Omit<IPlatform["put"], "id">, IReturnValue<any>>(
        {
            base: "PLATFORM",
            params: {
                id,
            },
        },
        {
            faName,
            enName,
            url,
            description,
            seoDescription,
            seoKeywords,
        },
    );

const Delete = async ({ id }: IPlatform["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "PLATFORM",
        params: {
            id,
        },
    });

const UploadFile = async ({ id, file }: { id: number; file: File }) => {
    const formData = new FormData();

    formData.append("image", file);

    return await new Request().post<
        FormData,
        IReturnValue<{
            url: string;
        }>
    >(
        {
            base: "PLATFORM_IMAGE",
            params: {
                id,
            },
        },
        formData,
    );
};

const DeleteImage = async ({ id }: IPlatform["delete"]) =>
    await new Request().delete<IReturnValue<any>>({
        base: "PLATFORM_IMAGE",
        params: {
            id,
        },
    });

// Main Object
const PlatformsApis = {
    GetAllWithoutFilter,
    GetAll,
    GetSingle,
    Create,
    Edit,
    Delete,
    UploadFile,
    DeleteImage,
};

export default PlatformsApis;
